import {
	FAIL,
	START,
	SUCCESS,
	DOSIER_FETCH_DOSIERS_DATA,
	DOSIER_SORTING,
	TYPE,
	DIRECTION,
	DOSIER_NEED_UPDATE,
	DOSIER_PAGE,
} from '../constants';
import { addJavaHeaders } from '../utils';
import type { TDispatch } from '../types/core';
import { checkStatus, parseJSON } from '../apiUtils';

export const startFetchingDosiersData = () => ({ type: DOSIER_FETCH_DOSIERS_DATA + START });

export const setDosiersData = (dosierData) => ({
	type: DOSIER_FETCH_DOSIERS_DATA + SUCCESS,
	payload: dosierData,
});

export const fetchingDosiersDataError = () => ({ type: DOSIER_FETCH_DOSIERS_DATA + FAIL });

export const getDosiersData =
	(params) =>
	async (dispatch: TDispatch, getState: () => any, { fetch }): any => {
		const {
			token: { token },
			dosier: { sortType, sortDirection },
			city,
		} = getState();

		dispatch(startFetchingDosiersData());

		const dosierUrl = '/lexsApi/developer/list';
		const fetchOptions = {
			method: 'POST',
			...addJavaHeaders(token),
			body: JSON.stringify({
				cityIds: city.cityIds,
				sort: `${sortDirection === 'down' ? '-' : ''}${sortType}`,
				...params,
			}),
		};

		try {
			return await fetch(dosierUrl, fetchOptions)
				.then(checkStatus)
				.then(parseJSON)
				.then((results) => {
					const { data } = results;

					dispatch(setDosiersData(data));
				});
		} catch (e) {
			dispatch(fetchingDosiersDataError());
			// eslint-disable-next-line no-console
			console.error(e);
		}

		return null;
	};

export const sortingTypeDosiers = (type) => ({
	type: DOSIER_SORTING + TYPE,
	payload: type,
});

export const sortingDirectionDosiers = (direction) => ({
	type: DOSIER_SORTING + DIRECTION,
	payload: direction,
});

export const changeDosiersPage = (page) => ({
	type: DOSIER_PAGE,
	payload: page,
});

export const needUpdateDosier = () => ({
	type: DOSIER_NEED_UPDATE,
});

export const getSortingDirectionDosiers = (data) => {
	if (data[0] === '-') {
		return 'down';
	}
	return 'up';
};
